export const DATE_FORMAT = "DD MMM YYYY";
export const TIME_FORMAT = "HH:mm";
export const DAY_FORMAT = "dddd";
export const MONTH_YEAR_FORMAT = "MMMM YYYY";
